export type Role = 
  | "admin"
  | "staff"
  | "buyer"
  | "seller"
  | "broker"
  | "consultant"
  | "lender"
  | "internal-partners"
  | "partner_lawyer"
  | "partner_immigration_lawyer"
  | "partner_notary"
  | "partner_cpa"
  | "partner_tax_advisor";

export function claimsToRoles(claims: any): Role[] {
  const roles: Role[] = [];
  
  if (claims.admin) roles.push("admin");
  if (claims.staff) roles.push("staff");
  if (claims.buyer) roles.push("buyer");
  if (claims.seller) roles.push("seller");
  if (claims.broker) roles.push("broker");
  if (claims.consultant) roles.push("consultant");
  if (claims.lender) roles.push("lender");
  if (claims.partner_lawyer) roles.push("partner_lawyer");
  if (claims.partner_immigration_lawyer) roles.push("partner_immigration_lawyer");
  if (claims.partner_notary) roles.push("partner_notary");
  if (claims.partner_cpa) roles.push("partner_cpa");
  if (claims.partner_tax_advisor) roles.push("partner_tax_advisor");
  if (claims.partner) roles.push("internal-partners");
  
  return roles;
}

// Priority order: more specific partner subroles win over the generic "partner",
// admin/staff win over everything else.
const ROLE_PRIORITY: Role[] = [
  "admin",
  "staff",
  "partner_lawyer",
  "partner_immigration_lawyer",
  "partner_notary",
  "partner_cpa",
  "partner_tax_advisor",
  "buyer",
  "seller",
  "broker",
  "consultant",
  "lender",
  "internal-partners",
];

export function pickPrimaryRole(roles: Role[] | string[] | undefined): Role | undefined {
  if (!roles || roles.length === 0) return undefined;
  for (const r of ROLE_PRIORITY) {
    if ((roles as string[]).includes(r)) return r;
  }
  return roles[0] as Role;
}

export const resolveDashboardRoute = roleToDefaultRoute;
export function roleToDefaultRoute(role: Role): string {
  const routes: Record<Role, string> = {
    admin: "/admin-dashboard",
    staff: "/staff-dashboard",
    buyer: "/buyer/dashboard",
    seller: "/seller/dashboard",
    broker: "/dashboard/broker",
    consultant: "/dashboard/consultant",
    lender: "/dashboard/lender",
    "internal-partners": "/internal-partners",
    "partner": "/internal-partners", 
    partner_lawyer: "/internal-partners/business-law",
    partner_immigration_lawyer: "/internal-partners/immigration-law",
    partner_notary: "/internal-partners/notary",
    partner_cpa: "/internal-partners/cpa",
    partner_tax_advisor: "/internal-partners/tax-advisor",
  };
  
  return routes[role] || "/dashboard";
}
